Auth = require 'db/auth'
PopOver = require 'views/lib/pop-over'
CardMemberSelectView = require 'views/card/card-member-select-view'
DatePickerView = require 'views/card/date-picker-view'
trackUe = require 'debug/trackUe'
{
  UP_NEXT_TYPE
  HIGHLIGHT_TYPE
  DUE_DATE_TYPE
  getOverflowItemsByFeedType
} = require './presentational/util/overflow-menu-items'

onClickSubscribe = (card) =>
  card.subscribe(true)
  PopOver.hide()

onClickUnsubscribe = (card) =>
  card.subscribe(false)
  PopOver.hide()

onClickDueDate = (card, modelCache) =>
  PopOver.pushView
    view: DatePickerView
    options: { model: card, modelCache }

onClickAddMembers = (card, modelCache) =>
  PopOver.pushView
    view: CardMemberSelectView
    options: { model: card, modelCache }

onClickJoinCard = (card) =>
  card.addMember(Auth.myId())
  PopOver.hide()

onClickLeaveCard = (card) =>
  card.removeMember(Auth.myId())
  PopOver.hide()

getOverflowItems = (card, type, modelCache, trackingPrepositionalObject = '', trackingIndirectObject = '') =>
  if type != UP_NEXT_TYPE && type != HIGHLIGHT_TYPE && type != DUE_DATE_TYPE
    throw new Error('invalid feed type')

  cardInfo =
    cardId: card.id
    editable: card.editable()
    isSubscribed: card.isSubscribed()
    hasDueDate: card.getDueDate()?
    hasMeAsMember: card.hasMember(Auth.myId())

  handlers =
    subscribe: => onClickSubscribe(card)
    unsubscribe: => onClickUnsubscribe(card)
    addDueDate: => onClickDueDate(card, modelCache)
    changeDueDate: => onClickDueDate(card, modelCache)
    addMembers: => onClickAddMembers(card, modelCache)
    joinCard: => onClickJoinCard(card)
    leaveCard: => onClickLeaveCard(card)

  tracking =
    prepObj: trackingPrepositionalObject
    indObj: trackingIndirectObject
    trackUe: trackUe

  return getOverflowItemsByFeedType(type, cardInfo, handlers, tracking)

module.exports = {
  getOverflowItems
  UP_NEXT_TYPE
  HIGHLIGHT_TYPE
  DUE_DATE_TYPE
}



// WEBPACK FOOTER //
// ./app/scripts/views/home/overflow-menu.coffee